import { render } from "./ItemPriceForm.vue?vue&type=template&id=9963eabe"
import script from "./ItemPriceForm.vue?vue&type=script&lang=js"
export * from "./ItemPriceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__